import React from 'react';
import HealthPackages from '../components/HealthPackages';

const Packages = () => {
    return <HealthPackages />;
};

export default Packages;